export default __webpack_public_path__ + "static/media/rare.79869566.svg";